export default {
    setQRCodeModal(state, data) {
        state.QRCodeModal = data;
    },
    setOrder(state, items) {
        state.items = items;
    },
    setPromoDiscount(state, discount) {
        state.promoDiscount = discount;
    },
    setPromoTotalWithDiscount(state, totalWithDiscount) {
        state.promoTotalWithDiscount = totalWithDiscount;
    },
    setPromoTotal(state, total) {
        state.promoTotal = total;
    },
    setPromoType(state, type) {
        state.promoType = type;
    },
    setPromoValue(state, promo) {
        state.promoValue = promo;
    },
    setPromoData(state, data) {
        state.promoData = data;
    },
    setPromoMessage(state, message) {
        state.promoMessage = message;
    },
    setLiveItems(state, val) {
        state.liveItems = val;
    },
    setLiveFreshItem(state, val) {
        state.liveFreshItem = val;
    },
    setCartOpenState(state, val) {
        state.isCartOpenState = val;
    },
    setPaymentData(state, val) {
        state.paymentData = val;
    },
    setAppliedBonuses(state, val) {
        state.appliedBonuses = Number(val);
    },
    setDiscountInfo(state, discountType) {
        state.discountInfo.isApply = true;
        state.discountInfo.discountType = discountType;
    },
    resetDiscountInfo(state) {
        state.discountInfo = {
            isApply: false,
            discountType: "",
        };
    },
    setIsDeliveresLoading(state, value) {
        state.isDeliveresLoading = value;
    },
};
